import type { SurveyQuestion } from '@/shared/api/queries'

export type AnswerValue = string | number | boolean | string[]

export interface AnswerProps {
  question: SurveyQuestion
  value: AnswerValue | undefined
  onChange: (value: AnswerValue | undefined) => void
  suggested?: string[] | undefined
}

// isAnswered is what the primary button is enabled by. An empty string and an
// empty list are «nothing chosen» rather than answers: the server would refuse
// them, and a button that submits a refusal is a button that lies.
export function isAnswered(value: AnswerValue | undefined): boolean {
  if (value === undefined) {
    return false
  }

  if (typeof value === 'string') {
    return value.trim() !== ''
  }

  return Array.isArray(value) ? value.length > 0 : true
}
